import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { config } from '../config';
import axios from 'axios';
import { validateEmail, validatePassword } from '../utils/validation';
import poweredByStrava from '../assets/power_by_strava.png';
import ScreenshotCarousel from '../components/ScreenshotCarousel';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [emailTouched, setEmailTouched] = useState(false)
  const [passwordTouched, setPasswordTouched] = useState(false)
  const [loginError, setLoginError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // Check if user is already logged in
    const sessionData = sessionStorage.getItem('sessionData');
    if (sessionData) {
      navigate('/dashboard');
    }
  }, [navigate]);


  const handleLogin = async (email, password) => {
    setEmailTouched(true)
    setPasswordTouched(true)
    setLoginError('')

    if (validateEmail(email) || validatePassword(password)) return

    setLoading(true)
    try {

      const response = await axios.post(
        `${config.getBackendUrl()}/strava_login`,
        new URLSearchParams({
          username: email,
          password: password,
        })
      );

      const metricsResponse = await axios.get(
        `${config.getBackendUrl()}/get_aerobic_metrics`,
        {
          params: {
            athlete_id: response.data.platform_athlete_id
          }
        }
      );


    response.data.aerobic_metrics = metricsResponse.data

    sessionStorage.setItem('sessionData', JSON.stringify(response.data));

    navigate('/dashboard');


  } catch (error) {
    const msg = error.response?.data?.detail || error.response?.data || error.message
    setLoginError(typeof msg === 'string' ? msg : 'Login failed. Please check your credentials.')
  } finally {
    setLoading(false)
  }

  };
  

  return (
    <div className="center-container">
      <div className="card">
        <img src={poweredByStrava} alt="Powered by Strava" style={{ width: '180px', margin: '8px auto 24px' }} />
        <p style={{ marginBottom: '24px', color: '#666' }}>
          Connect your Strava account to view your running analytics
        </p>
        <form onSubmit={(e) => { e.preventDefault(); handleLogin(email, password); }}>
        <div className="field-wrapper">
          <label className="field-label" htmlFor="email">Email</label>
          <input
            id="email"
            className={`input${emailTouched && validateEmail(email) ? ' input-invalid' : emailTouched && !validateEmail(email) ? ' input-valid' : ''}`}
            type="email"
            placeholder=""
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => setEmailTouched(true)}
          />
          {emailTouched && validateEmail(email) && (
            <p className="field-error">{validateEmail(email)}</p>
          )}
        </div>
        <div className="field-wrapper">
          <label className="field-label" htmlFor="password">Password</label>
          <input
            id="password"
            className={`input${passwordTouched && validatePassword(password) ? ' input-invalid' : passwordTouched && !validatePassword(password) ? ' input-valid' : ''}`}
            type="password"
            placeholder=""
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onBlur={() => setPasswordTouched(true)}
          />
          {passwordTouched && validatePassword(password) && (
            <p className="field-error">{validatePassword(password)}</p>
          )}
        </div>
        {loginError && <p className="field-error">{loginError}</p>}
        <button type="submit" className="button" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        </form>
        <p style={{ marginTop: '16px' }}>
          Not signed up? <Link to="/sign_up">Create an account</Link>
        </p>
        <p style={{ marginTop: '8px' }}>
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
      </div>
      <ScreenshotCarousel />
    </div>
  );
}

export default Login;
